import { boolValOrUndef, listVal, nbValOrUndef, strVal } from "@paroi/data-formatters-lib";

export interface APIColumnOption {
  key: string;
  value: string;
}

export interface TableForm {
  label: string;
  name: string;
  type?: TableFormType;
  length?: number;
  required: boolean;
  unique: boolean;
  default?: number | string | boolean;
  data_source?: TableFormDataSourceKeyValue | TableFormDataSourceAPIAndRelation;
  // TODO: Should we support relation data source here?
  // | TableFormDataSourceRelation;
}

type TableFormType =
  | "enum"
  | "string"
  | "number"
  | "boolean"
  | "date"
  | "datetime"
  | "time"
  | "file";

interface TableFormDataSourceKeyValue {
  type: "key_value";
  values: { key: string; value: string }[];
}

interface TableFormDataSourceAPIAndRelation {
  type: "api" | "relation";
  apiUrl: string;
}

// TODO: Should we support relation data source here?
// interface TableFormDataSourceRelation {
//   type: "relation";
//   config: TableFormDataSourceRelationConfig;
// }

// interface TableFormDataSourceRelationConfig {
//   relationTable: string;
//   relationTableColumn: string;
// }

export function formatFetchAPIColumnOptionsAPI(data: unknown): APIColumnOption[] {
  if (typeof data !== "object" || data === null || Array.isArray(data)) {
    throw new Error("Invalid data");
  }
  const options: APIColumnOption[] = [];
  for (const [key, value] of Object.entries(data)) {
    options.push({ key: strVal(key).trim(), value: strVal(value) });
  }
  if (options.length === 0) return [];
  return options;
}

export function formatFetchTableFormAPI(data: unknown): TableForm[] {
  if (!Array.isArray(data))
    return listVal(
      Object.values(data as Record<string, unknown>),
      formatToTableForm
    );
  return listVal(data, formatToTableForm);
}

function formatToTableForm(data: unknown): TableForm {
  if (typeof data !== "object" || data === null) {
    throw new Error("Invalid data");
  }
  const validData = data as Record<string, unknown>;
  return {
    label: strVal(validData.label),
    name: strVal(validData.name),
    type: formatType(validData.type),
    length: nbValOrUndef(validData.length),
    required: boolValOrUndef(validData.required) ?? false,
    unique: boolValOrUndef(validData.unique) ?? false,
    default: formatDefault(validData.default),
    data_source: formatDataSource(validData.data_source),
  };
}

function formatType(data: unknown): TableFormType | undefined {
  let type = strVal(data);
  if (type === "char") type = "string";
  if (["enum", "string", "number", "boolean", "date", "datetime", "time", "file"].includes(type)) {
    return type as TableFormType;
  }
  return;
}

function formatDefault(data: unknown): number | string | boolean | undefined {
  if (typeof data === "number" || typeof data === "string" || typeof data === "boolean") {
    return data;
  }
  return;
}

function formatDataSource(data: unknown):
  | TableFormDataSourceKeyValue
  | TableFormDataSourceAPIAndRelation
  // | TableFormDataSourceRelation
  | undefined {
  if (typeof data !== "object" || data === null) {
    throw new Error("Invalid data source");
  }
  if (Array.isArray(data) || !("type" in data)) return;
  const validData = data as Record<string, unknown>;
  const type = strVal(validData.type);
  if (type === "key_value") {
    if (
      !("data" in validData) ||
      typeof validData.data !== "object" ||
      validData.data === null ||
      Array.isArray(validData.data)
    ) {
      throw new Error("Invalid key_value data source");
    }
    const values: { key: string; value: string }[] = [];
    for (const [key, value] of Object.entries(validData.data)) {
      values.push({ key: strVal(key).trim(), value: strVal(value) });
    }
    return {
      type: "key_value",
      values,
    };
  }

  if (type === "api" || type === "relation") {
    if ("api_url" in validData) {
      return {
        type: type as "api" | "relation",
        apiUrl: strVal(validData.api_url),
      };
    }

    // if (type === "relation" && "config" in validData) {
    //   const config = validData.config;
    //   if (
    //     typeof config !== "object" ||
    //     config === null ||
    //     Array.isArray(config) ||
    //     !("relation_table" in config) ||
    //     !("relation_table_column" in config)
    //   ) {
    //     throw new Error("Invalid relation data source config");
    //   }
    //   return {
    //     type: "relation",
    //     config: {
    //       relationTable: strVal(config.relation_table),
    //       relationTableColumn: strVal(config.relation_table_column),
    //     },
    //   };
    // }
    return;
  }
  return;
}
